/**
 * The visible name of the global floating assistant (the wand button, bottom-right).
 * Zeus, to match the agent's name in Google Chat (Nick, 2026-10-05). It used to be "Al".
 *
 * Change the name HERE and nowhere else. Other "AI" labels in the app are different things and
 * keep their own names: CRM "Ask AI about this lead", SmartDocFill, Mary-AI, the AI Systems module.
 */
export const ASSISTANT_NAME = 'Zeus';
